const TAGS = ["黑料色动图", "黑料色短视频", "黑料色录屏", "黑料色片段", "黑料色剪辑", "黑料色表情包", "高能反转", "神回复现场", "名场面台词", "直播回放", "翻车记录", "氛围短片"];

const QUICK = [
  { label: "按场景切片", href: "#scene" },
  { label: "大图卡片流", href: "#stream" },
  { label: "热场弹幕", href: "#buzz" },
  { label: "今日热榜", href: "#rank" },
  { label: "怎么找", href: "#howto" },
  { label: "常见问题", href: "#faq" },
];

export default function Footer() {
  return (
    <footer className="w-full bg-background-200/60">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.2fr_0.8fr_1.1fr]">
          {/* 品牌区 */}
          <div>
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-play-list-fill text-lg" />
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-lg font-black text-foreground-950">黑料色</span>
                <span className="mt-1 text-[11px] tracking-wide text-foreground-500">按场景切片的资源站</span>
              </span>
            </a>
            <p className="mt-5 max-w-sm text-sm leading-7 text-foreground-600">
              黑料色动图、短视频、录屏片段与表情包按场景整理好，打开就能看。
              想找黑料色动态图、视频剪辑或录屏资源，从这里开始就好。
            </p>
            <p className="mt-4 text-xs leading-6 text-foreground-500">
              内容均来自公开网络整理，仅作娱乐参考与界面演示，不涉及真实人物隐私与交易。
            </p>
          </div>

          {/* 导航区 */}
          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950">快速直达</h4>
            <div className="mt-4 flex flex-col items-start gap-2.5">
              {QUICK.map((q) => (
                <a
                  key={q.href}
                  href={q.href}
                  className="group flex items-center gap-1.5 text-sm text-foreground-600 transition hover:text-primary-700"
                >
                  <i className="ri-arrow-right-s-line text-primary-600 opacity-0 transition group-hover:opacity-100" />
                  {q.label}
                </a>
              ))}
            </div>
          </div>

          {/* 关键词区 */}
          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950">常搜的关键词</h4>
            <div className="mt-4 flex flex-wrap gap-2">
              {TAGS.map((t) => (
                <a
                  key={t}
                  href="#scene"
                  className="whitespace-nowrap rounded-full bg-background-50 px-3 py-1.5 text-xs text-foreground-600 transition hover:bg-primary-100 hover:text-primary-800"
                >
                  {t}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-background-300/70 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-foreground-500">
            © 2026 黑料色 · 仅用于界面展示，不构成真实内容服务。
          </p>
          <a
            href="#top"
            className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-background-50 px-3 py-1.5 text-xs font-medium text-foreground-700 transition hover:bg-primary-100"
          >
            回到顶部
            <i className="ri-arrow-up-line text-primary-600" />
          </a>
        </div>
      </div>
    </footer>
  );
}